import { render, staticRenderFns } from "./SelfService.vue?vue&type=template&id=8e250f44&"
import script from "./SelfService.vue?vue&type=script&lang=js&"
export * from "./SelfService.vue?vue&type=script&lang=js&"
import style0 from "./SelfService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports